import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="colonne">
        <h1>Me Contacter</h1>
        <a href="mailto:prince-benjamin@hotmail.com">
          <p>prince-benjamin@hotmail.com</p>
        </a>
        <p>06.42.57.73.64</p>
        <p>Lyon</p>
        <p>Copyright © 2024 Benjamin PRINCE</p>
      </div>
    </footer>
  );
};

export default Footer;
